import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

import { CHIP_DESIGNS, ChipDesign } from "../../shared/chip-colors";

import { BvChipComponent } from "./chip.component";

/**
 * Chip design picker. Renders one preview chip per registered design and
 * highlights the selected one. Two-way bound via `value` / `valueChange`.
 *
 *   <bv-chip-design-picker
 *     [(value)]="chipColor.design"
 *     [primary]="chipColor.p"
 *     [secondary]="chipColor.s"
 *     [disabled]="!chipColor.s">
 *   </bv-chip-design-picker>
 */
@Component({
    selector: "bv-chip-design-picker",
    templateUrl: "./chip-design-picker.component.html",
    styleUrls: ["./chip-design-picker.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: "bv-chip-design-picker",
        "[class.bv-chip-design-picker--disabled]": "disabled",
    },
    imports: [BvChipComponent]
})
export class BvChipDesignPickerComponent {
  @Input() value: string | null = null;
  @Input() primary: string | null = null;
  @Input() secondary: string | null = null;
  @Input() disabled = false;

  @Output() valueChange = new EventEmitter<string>();

  readonly designs: ChipDesign[] = CHIP_DESIGNS;

  trackById(_i: number, d: ChipDesign): string {
    return d.id;
  }

  pick(id: string): void {
    if (this.disabled || this.value === id) return;
    this.value = id;
    this.valueChange.emit(id);
  }
}
